<div class="modal-header" ngbAutofocus>
    <h3 class="modal-title">Expense Approval</h3>
</div>
<div class="modal-body">
    <p><b>Notes:</b><br/>
        {{data.RejectedNotes}}
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>